import Icon from "@/common/components/Icon";

export const getRaws = (data, setElement) =>
	data.map((element, i) => (
		<tr key={element._id}>
			<td>{i + 1}.</td>
			<td>{element.data[0].name}</td>
			<td>
				{element.data
					?.map((template) => template.mail_template_ids.template_sengrid_name)
					.join(', ') || '-----'}
			</td>
			<td>
				<Icon 
					name='edit'
					style={{ cursor: 'pointer' }}
					onClick={() => setElement(element)}
				/>
			</td>
		</tr>
	));
